import React, { memo } from 'react';
import { string, bool, func, number, oneOfType, node } from 'prop-types';

import ErrorMessage from 'components/ErrorMessage';

const TextArea = ({
  testId,
  label,
  name,
  register,
  required,
  placeholder,
  className,
  error,
  isDisabled,
  rows,
  maxLength,
  hasLimit,
  labelClassName,
  count,
}) => {
  return (
    <label
      htmlFor={name}
      className={`flex flex-1 flex-col lg:items-center mb-4 lg:flex-row ${className}`}
    >
      <span className={`label  ${labelClassName}`}>{label}</span>
      <div className="input-form-wrapper">
        <textarea
          {...register(name, { required })}
          id={name}
          data-testid={testId}
          className={`input input-full-border h-auto resize-none ${
            !!error ? 'error' : ''
          }`}
          placeholder={placeholder}
          rows={rows}
          disabled={isDisabled}
          maxLength={maxLength}
        />
        {hasLimit && (
          <p className="text-xs mt-2 text-gray-500">{`${count} / ${maxLength}`}</p>
        )}
        {!!error && <ErrorMessage message={error} />}
      </div>
    </label>
  );
};

TextArea.propTypes = {
  className: string,
  testId: string,
  name: string,
  label: oneOfType([string, node]),
  register: func,
  required: bool,
  placeholder: string,
  error: string,
  isDisabled: bool,
  rows: number,
  maxLength: number,
  count: number,
  labelClassName: string,
};
TextArea.defaultProps = {
  className: '',
  testId: 'textarea',
  label: '',
  name: 'textarea',
  required: false,
  register: () => null,
  placeholder: null,
  error: null,
  isDisabled: false,
  rows: 3,
  maxLength: undefined,
  count: 0,
  labelClassName: 'pb-1 lg:pb-0 lg:w-4/12',
};

export default memo(TextArea);
